import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-page-sponsors-item',
  templateUrl: './event-page-sponsors-item.component.html',
  styleUrls: ['./event-page-sponsors-item.component.scss']
})
export class EventPageSponsorsItemComponent implements OnInit {

  @Input() sponsor = null;

  public imageUrl = '';

  constructor() { }

  ngOnInit(): void {
    this.imageUrl = this.sponsor.imageUrl  || '/images/org_logo_default_v2.svg'
  }

}
